"use strict";
exports.__esModule = true;
exports.DEPLOYMENT_OPTIONS = exports.DEPLOYMENT_PATHS = exports.CHANNEL_TABS = exports.CHANNEL_PATHS = void 0;
exports.CHANNEL_PATHS = {
    SDK_CONFIGURATIONS: 'sdk-configurations',
    PLATFORM_DEPLOYMENTS: 'platform-deployments',
};
exports.CHANNEL_TABS = [
    {
        title: 'SDK Configurations',
        path: exports.CHANNEL_PATHS.SDK_CONFIGURATIONS,
    },
    {
        title: 'Platform Deployments',
        path: exports.CHANNEL_PATHS.PLATFORM_DEPLOYMENTS,
    },
];
exports.DEPLOYMENT_PATHS = {
    FACEBOOK: 'facebook',
    JIO: 'jio',
    BOT_API: 'bot-api',
    WEB_SDK: 'web-sdk',
    WHATSAPP: 'whatsapp',
    IOS_SDK: 'ios-sdk',
    ANDROID_SDK: 'android-sdk',
    JIO_CHAT_CONNECTOR: 'jio-chat-connector',
    GUPSHUP_CHAT_CONNECTOR: 'gupshup-chat-connector',
    NETCORE_CHAT_CONNECTOR: 'netcore-chat-connector',
    GOOGLE_BUSINESS_MESSAGES: 'google-business-messages',
    SUNSHINE_CHAT_CONNECTOR: 'sunshine-chat-connector',
    GIP: 'gip',
    IVR_AUDIO_CODES: 'ivr-audio-codes',
    TWILIO: 'twilio',
    IVR_APIS: 'ivr-apis',
    INFOBIP_CHAT_CONNECTOR: 'infobip-chat-connector',
    TELEGRAM: 'Telegram',
    SHOPIFY_CONNECTOR: 'shopify-connector',
    MICROSOFT_TEAMS: 'microsoft-teams',
    KMS_INTEGRATION: 'KMSIntegration',
    INSTAGRAM: 'Instagram',
    LINE: 'Line',
    INSTAGRAM_CLASSIC: 'instagram-classic',
    VIVA_CONNECT: 'viva-connect',
    GORGIAS_WIDGET: 'gorgias-widget',
    MAGENTO: 'Magento',
    FYND: 'fynd',
    CLEVERTAP: 'clevertap',
    WOOCOMMERCE: 'WooCommerce',
    RADISYS: 'RADISYS',
    MICROSOFT_DYNAMIC_365: 'Microsoft Dynamic 365',
};
exports.DEPLOYMENT_OPTIONS = [
    {
        title: 'Facebook',
        path: exports.DEPLOYMENT_PATHS.FACEBOOK,
    },
    {
        title: 'JIO',
        path: exports.DEPLOYMENT_PATHS.JIO,
    },
    {
        title: 'Bot API',
        path: exports.DEPLOYMENT_PATHS.BOT_API,
    },
    {
        title: 'Web SDK',
        path: exports.DEPLOYMENT_PATHS.WEB_SDK,
    },
    {
        title: 'WhatsApp',
        path: exports.DEPLOYMENT_PATHS.WHATSAPP,
    },
    {
        title: 'IOS SDK',
        path: exports.DEPLOYMENT_PATHS.IOS_SDK,
    },
    {
        title: 'Android SDK',
        path: exports.DEPLOYMENT_PATHS.ANDROID_SDK,
    },
    {
        title: 'Jio Chat Connector',
        path: exports.DEPLOYMENT_PATHS.JIO_CHAT_CONNECTOR,
    },
    {
        title: 'Gupshup Chat Connector',
        path: exports.DEPLOYMENT_PATHS.GUPSHUP_CHAT_CONNECTOR,
    },
    {
        title: 'Netcore Chat Connector',
        path: exports.DEPLOYMENT_PATHS.NETCORE_CHAT_CONNECTOR,
    },
    {
        title: 'Google Business Messages',
        path: exports.DEPLOYMENT_PATHS.GOOGLE_BUSINESS_MESSAGES,
    },
    {
        title: 'Sunshine Conversations',
        path: exports.DEPLOYMENT_PATHS.SUNSHINE_CHAT_CONNECTOR,
    },
    {
        title: 'GIP',
        path: exports.DEPLOYMENT_PATHS.GIP,
    },
    {
        title: 'IVR Audio codes',
        path: exports.DEPLOYMENT_PATHS.IVR_AUDIO_CODES,
    },
    {
        title: 'Twilio',
        path: exports.DEPLOYMENT_PATHS.TWILIO,
    },
    {
        title: 'IVR APIs',
        path: exports.DEPLOYMENT_PATHS.IVR_APIS,
    },
    {
        title: 'Infobip Chat Connector',
        path: exports.DEPLOYMENT_PATHS.INFOBIP_CHAT_CONNECTOR,
    },
    {
        title: 'Telegram',
        path: exports.DEPLOYMENT_PATHS.TELEGRAM,
    },
    {
        title: 'Shopify Connector',
        path: exports.DEPLOYMENT_PATHS.SHOPIFY_CONNECTOR,
    },
    {
        title: 'Microsoft Teams',
        path: exports.DEPLOYMENT_PATHS.MICROSOFT_TEAMS,
    },
    {
        title: 'KMS Integration',
        path: exports.DEPLOYMENT_PATHS.KMS_INTEGRATION,
    },
    {
        title: 'Instagram',
        path: exports.DEPLOYMENT_PATHS.INSTAGRAM,
    },
    {
        title: 'Line',
        path: exports.DEPLOYMENT_PATHS.LINE,
    },
    {
        title: 'Instagram Classic',
        path: exports.DEPLOYMENT_PATHS.INSTAGRAM_CLASSIC,
    },
    {
        title: 'Viva Connect',
        path: exports.DEPLOYMENT_PATHS.VIVA_CONNECT,
    },
    {
        title: 'Gorgias Widget',
        path: exports.DEPLOYMENT_PATHS.GORGIAS_WIDGET,
    },
    {
        title: 'Magento',
        path: exports.DEPLOYMENT_PATHS.MAGENTO,
    },
    {
        title: 'Fynd Platform',
        path: exports.DEPLOYMENT_PATHS.FYND,
    },
    {
        title: 'Clevertap',
        path: exports.DEPLOYMENT_PATHS.CLEVERTAP,
    },
    {
        title: 'WooCommerce',
        path: exports.DEPLOYMENT_PATHS.WOOCOMMERCE,
    },
    {
        title: 'Radisys',
        path: exports.DEPLOYMENT_PATHS.RADISYS,
    },
    {
        title: 'Microsoft Dynamic 365',
        path: exports.DEPLOYMENT_PATHS.MICROSOFT_DYNAMIC_365,
    },
];
